class ImpactText extends HTMLElement {
  connectedCallback() {
    // 若不需要动画或不在视口中，则跳过
    if (!this.hasAttribute("count-up")) return;

    const rawText = this.textContent.trim();
    const match = rawText.match(/\d+(?:[., ]\d+)*/);
    if (!match) return;

    const formatted = match[0];
    const unformatted = parseInt(formatted.replace(/[,.\s]+/g, ""));

    const span = document.createElement("span");
    span.textContent = "0";
    this.innerHTML = rawText.replace(formatted, span.outerHTML);

    const target = this.querySelector("span");
    const duration = parseFloat(this.getAttribute("count-up")) * 1000 || 2000;

    let startTime = null;
    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const current = Math.floor(progress * unformatted);
      target.textContent = current.toLocaleString();

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    // 进入视口时触发
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        requestAnimationFrame(animate);
        observer.disconnect();
      }
    }, { threshold: 0.6 });

    observer.observe(this);
  }
}

// 注册组件（避免重复定义）
if (!customElements.get("impact-text")) {
  customElements.define("impact-text", ImpactText);
}